import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { RouterModule } from '@angular/router'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiEditPersonaModule } from '../lib/shared-ui-edit-persona.module'
import { EditPersonaDocsComponent } from './edit-persona-docs/edit-persona-docs.component'
import { EditPersonaChildExampleComponent } from './edit-persona-docs/examples/edit-persona-child-example.component'
import { EditPersonaSelfExampleComponent } from './edit-persona-docs/examples/edit-persona-self-example.component'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'

@NgModule({
  declarations: [
    EditPersonaDocsComponent,
    EditPersonaChildExampleComponent,
    EditPersonaSelfExampleComponent
  ],
  exports: [EditPersonaDocsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiEditPersonaModule
  ],
})
export class SharedUiEditPersonaDocsModule { }
